export default "__VITE_PUBLIC_ASSET__d73203fe__"